import { useState, useMemo, useCallback } from 'react'

export default function DropModule({
    onDropFiles, //required func
    onDropCustom, //required func
    onDropLinks, //required func
    validateCustom, //(type)
    children
}) {
    const blockSelf = useMemo(() => String(new Date().getTime()), [])

    const [isDropping, setIsDropping] = useState(false)

    const validate = useCallback((e) => {
        let contains = null

        if (e.dataTransfer.types.includes(blockSelf)) return false

        for (const record of e.dataTransfer.items) {
            //file
            if (record.kind === 'file') {
                contains = 'file'
                break
            }

            //custom
            if (validateCustom && validateCustom(record.type)) {
                contains = record.type
                break
            }

            //link
            if (record.type === 'text/uri-list') {
                contains = 'link'
                break
            }
        }

        return contains
    }, [blockSelf, validateCustom])

    const dropHandlers = useMemo(
        () => ({
            onDrop: (e) => {
                if (!validate(e)) return false

                e.preventDefault()
                e.stopPropagation()

                let files = []
                let links = []
                let custom = []

                for (const record of e.dataTransfer.items) {
                    //file
                    if (
                        record.kind === 'file' &&
                        record.type &&
                        onDropFiles
                    )
                        files.push(record.getAsFile())
                    //custom
                    else if (
                        onDropCustom &&
                        validateCustom &&
                        validateCustom(record.type)
                    ) {
                        const data =
                            e.dataTransfer.getData(record.type) || ''

                        try {
                            const json = JSON.parse(data)
                            custom.push([record.type, json])
                        } catch (e) {
                            throw new Error(
                                'drag data is incorrect json: ' + String(data)
                            )
                        }
                    }
                    //text links
                    else if (record.type == 'text/plain') {
                        const found = e.dataTransfer
                            .getData(record.type)
                            .split('\n')
                            .map((v) => v.trim())
                            .filter((v) => {
                                try {
                                    return new URL(v).host != location.host
                                } catch (e) {
                                    return false
                                }
                            })

                        for (const link of found)
                            if (!links.includes(link)) links.push(link)
                    }
                    //link
                    else if (record.type == 'text/uri-list') {
                        const link = e.dataTransfer.getData(record.type)
                        if (
                            new URL(link).host != location.host &&
                            !links.includes(link)
                        )
                            links.push(link)
                    }
                }

                if (files.length) onDropFiles(files)

                //do not send both of them
                if (custom.length) onDropCustom(custom)
                else if (links.length) onDropLinks(links)

                if (isDropping) setIsDropping(false)

                return false
            },

            onDragStart: (e) => {
                e.dataTransfer.setData(blockSelf, '')
            },

            onDragOver: (e) => {
                if (validate(e)) {
                    e.preventDefault()
                    e.stopPropagation()
                    //don't change dropEffect! on safari and firefox(win) prevent drop

                    if (!isDropping) setIsDropping(true)
                }
            },

            onDragLeave: () => {
                if (isDropping) setIsDropping(false)
            },
        }),
        [validate, blockSelf, onDropFiles, onDropCustom, onDropLinks, isDropping]
    )

    return children({
        isDropping,
        dropHandlers,
    })
}
